class ReportQueueService {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }

  async addReportJob(reportParam) {
    return await this.apiClient.post("reportqueue/submitjob", reportParam, {
      headers: { "Content-Type": "application/json" },
    }
    );
  }

  async getReportQueueRecords(entityId) {
      return this.apiClient.get(`reportqueue/activity/adhoc/${entityId}`);
  }
  
  async cancelReport(params) {
    return await this.apiClient.delete("reportqueue/cancelreport", {
      data: params,
      headers: { "Content-Type": "application/json" },
    });
  }

  async getQueuedReportUrl(rqId) {
    return this.apiClient.get(`reportqueue/getqueuedreporturl/${rqId}`);
  }

  async getAllQueueProcessingReports() {
    return this.apiClient.get(`reportqueue/activity/all`);
  }

  async updateThreadCount(taskCount) {
    return this.apiClient.post(`reportqueue/updatethreadcount`,{ taskCount }, {
      headers: { "Content-Type": "application/json" },
    })
  }
}

export default ReportQueueService;
